import { PlpAllListComponent } from "./plp/plp-all-list/plp-all-list.component";
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { CLPComponent } from "./clp/clp.component";
import { PLPComponent } from "./plp/plp.component";
import { PlpListComponent } from "./plp/plp-list/plp-list.component";

const routes: Routes = [
  {
    path: "",
    component: CLPComponent,
  },
  {
    path: ":id",
    component: PLPComponent,
  },

  {
    path: "list/:id",
    component: PlpAllListComponent,
  },
  {
    path: "listItem/:id",
    component: PlpListComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CLPRoutingModule { }
